import { useEffect, useState, useRef } from 'react';
import { resolveWebSocketUrl } from '../utils/websocketUrl';

export const useWebSocket = (url) => {
  const [lastMessage, setLastMessage] = useState(null);
  const [readyState, setReadyState] = useState(WebSocket.CONNECTING);
  const ws = useRef(null);
  
  useEffect(() => {
    const wsUrl = resolveWebSocketUrl(url);
    console.log('Connecting to WebSocket:', wsUrl);

    try {
      ws.current = new WebSocket(wsUrl);
    } catch (error) {
      console.error('WebSocket constructor failed:', error);
      setReadyState(WebSocket.CLOSED);
      return undefined;
    }
    
    ws.current.onopen = () => {
      console.log('WebSocket connected');
      setReadyState(WebSocket.OPEN);
    };
    
    ws.current.onclose = () => {
      console.log('WebSocket disconnected');
      setReadyState(WebSocket.CLOSED);
    };
    
    ws.current.onmessage = (event) => {
      setLastMessage(event);
    };
    
    ws.current.onerror = (error) => {
      console.error('WebSocket error:', error);
    };
    
    return () => {
      if (ws.current) {
        ws.current.close();
      }
    };
  }, [url]);
  
  const sendMessage = (message) => {
    if (ws.current && ws.current.readyState === WebSocket.OPEN) {
      ws.current.send(JSON.stringify(message));
    }
  };
  
  return { lastMessage, readyState, sendMessage };
};

